module.exports = __webpack_public_path__ + "img/northern-marianas-islands.87e1b09e.svg";